// SPDX-License-Identifier: AGPL-3.0-or-later

const pad = (value: number) => String(value).padStart(2, '0');

// The value format of <input type="datetime-local">, in the member's own time zone.
export function toLocalInputValue(date: Date): string {
	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function fromLocalInputValue(value: string): Date | null {
	if (!value) return null;
	const date = new Date(value);
	return Number.isNaN(date.getTime()) ? null : date;
}

export function formatEventRange(locale: string, startIso: string, endIso: string): string {
	const start = new Date(startIso);
	const end = new Date(endIso);
	const dateTime = new Intl.DateTimeFormat(locale, {dateStyle: 'medium', timeStyle: 'short'});
	const sameDay = start.toDateString() === end.toDateString();
	if (sameDay) {
		const time = new Intl.DateTimeFormat(locale, {timeStyle: 'short'});
		return `${dateTime.format(start)} – ${time.format(end)}`;
	}
	return `${dateTime.format(start)} – ${dateTime.format(end)}`;
}
